__turbopack_context__.v({
  "className": "qlqyJa_className",
  "variable": "qlqyJa_variable",
});
